import Cookies from 'js-cookie'

export function redirectUnauthenticatedUser (path) {
  Cookies.remove(process.env.VUE_APP_COOKIE_NAME, {
    domain: window.location.hostname.replace('www.', '')
  })
  window.open(path, '_self')
}
